import { gql } from '@apollo/client';

export const getPushNotificationTemplatesList = gql`
  query getPushNotificationTemplatesList($searchKey: String, $currentPage: Int, $defaultLocaleOnly: Boolean, $locale: String) {
    getPushNotificationTemplatesList(searchKey: $searchKey, currentPage: $currentPage, defaultLocaleOnly: $defaultLocaleOnly, locale: $locale) {
    status
    errorMessage
      results {
        id
        type
        locale
        title
        messageBody
      }
      count
    }
  }
`;

export const getPushNotificationTemplate = gql`
  query getPushNotificationTemplate($type: String, $locale: String) {
    getPushNotificationTemplate(type: $type, locale: $locale) {
      status
      errorMessage
      id
      type
      locale
      title
      messageBody
    }
  }
`;

export const getPushNotificationTemplatesByType = gql`
  query getPushNotificationTemplatesByType($type: String!) {
    getPushNotificationTemplatesByType(type: $type) {
      id
      type
      locale
      title
      messageBody
    }
  }
`;
